import { Box, FormControl, FormHelperText } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import PropTypes from "prop-types";
import { convertToDefEventPara } from "../helper.js";

const ACCENT = "#4A78BC";

/**
 * ChipToggle — the click dummy's `chip()`: a single boolean toggle rendered as a
 * pill with an inline checkbox glyph (not the MUI square checkbox). Drop-in
 * replacement for the `checkbox` control inside the schmidt claim wizard, where
 * every yes/no attachment/consent flag reads as a chip. Writes the same boolean
 * value shape as the checkbox it replaces.
 */
export default function ChipToggle(props) {
  const {
    item,
    value = false,
    onChange,
    error,
    showErrorText = false,
    disabled = false,
  } = props;

  const on = Boolean(value);

  let helperText = "";
  if (showErrorText) helperText = error;
  else if (item.help) helperText = item.help;

  return (
    <FormControl {...(error && { error: true })} sx={{ width: "100%" }}>
      <Box
        component="button"
        type="button"
        disabled={disabled}
        onClick={() => !disabled && onChange(convertToDefEventPara(item.name, !on))}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: "9px",
          alignSelf: "flex-start",
          px: "15px",
          py: "9px",
          borderRadius: "9px",
          fontSize: "13.5px",
          fontWeight: 500,
          fontFamily: "inherit",
          textAlign: "left",
          cursor: disabled ? "default" : "pointer",
          border: `1.5px solid ${on ? ACCENT : "#dde3ec"}`,
          backgroundColor: on ? "#EEF3FB" : "#fff",
          color: on ? "#3A6099" : "#6b7280",
        }}
      >
        <Box
          component="span"
          sx={{
            width: "17px",
            height: "17px",
            borderRadius: "5px",
            flex: "none",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: on ? ACCENT : "#fff",
            border: on ? "none" : "1.5px solid #cbd5e1",
          }}
        >
          {on ? <CheckIcon sx={{ fontSize: 12, color: "#fff" }} /> : null}
        </Box>
        {item.label}
      </Box>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}

ChipToggle.propTypes = {
  item: PropTypes.object.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  showErrorText: PropTypes.bool,
  disabled: PropTypes.bool,
};
